import React, { useContext, useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@mui/material';

import { useFetch } from '../auth/useFetch';

import ProjectContext from '../../contexts/ProjectContext';

import ItemList from '../menuitem/ItemList';


export default function ExportCdlDialog(props) {
    const { open, setOpen, type, generateCDLEDL, toggleCdlUploadMenu, downloadExport, toggleCdlExport, setCdlUploadSource, selectCount, show } = props
    const { isAuthenticated } = useAuth0();

    const fetchWithAuth = useFetch()
    const projectContext = useContext(ProjectContext);

    const [exports, setExports] = useState([])

    const handleClose = () => {
        setOpen(false);
    };

    // TODO: Check if Livegrade is in use in the project and disable/hide livegrade options if not
    // TODO: Do better checks on backend if no Livegrade for the selected shot(s)
    let livegrade_in_use = true

    useEffect(() => {
        const url = `${process.env.REACT_APP_BACKEND_URL}/konsol/exportale`

        isAuthenticated && (async () => {
        if (type == 'CDL'){   
            let export_list = [
                { name: 'OSD Grade (Colorfront)', source: 'Colorfront', type: 'Individual CDLs', action: 'download'},
                { name: 'OSD Grade (Colorfront)', source: 'Colorfront', type: 'CDL Collection', action: 'download'},
                { name: 'OSD Grade (Colorfront)', source: 'Colorfront', type: 'Individual CCCs', action: 'download'},
                { name: 'OSD Grade (Colorfront)', source: 'Colorfront', type: 'CCC Collection', action: 'download'},
                { name: 'OSD Grade (Colorfront)', source: 'Colorfront', type: 'Individual CCs', action: 'download'},
                { name: 'OSD Grade (Colorfront)', source: 'Colorfront', type: 'Generate EDL with color data', action: 'generate_inject'},
                { name: 'OSD Grade (Colorfront)', source: 'Colorfront', type: 'Insert color data into uploaded EDL', action: 'upload_inject'},
            ]     
            if (livegrade_in_use){
                export_list.push(
                    { name: 'DIT Grade (Livegrade)', source: 'Livegrade', type: 'Individual CDLs', action: 'download'},
                    { name: 'DIT Grade (Livegrade)', source: 'Livegrade', type: 'CDL Collection', action: 'download'},
                    { name: 'DIT Grade (Livegrade)', source: 'Livegrade', type: 'Individual CCCs', action: 'download'},
                    { name: 'DIT Grade (Livegrade)', source: 'Livegrade', type: 'CCC Collection', action: 'download'},
                    { name: 'DIT Grade (Livegrade)', source: 'Livegrade', type: 'Individual CCs', action: 'download'},
                    { name: 'DIT Grade (Livegrade)', source: 'Livegrade', type: 'Generate EDL with color data', action: 'generate_inject'},
                    { name: 'DIT Grade (Livegrade)', source: 'Livegrade', type: 'Insert color data into uploaded EDL', action: 'upload_inject'},
                )
            }
            setExports(export_list)    
        }else{
            try {
                await fetchWithAuth(url, {
                    headers: {
                        'X-Project-ID': projectContext?.project_db
                    },
                })
                    .then((response) => response.json())
                    .then((res) => {
                        setExports(res.filter((item) => {return item.type === 'ALE' || item.type === 'PDF'}))
                    })
            } catch (e) {
                console.error(e);
            }
        }
        
        })();
    }, [isAuthenticated])

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        width: "auto",
                        height: "auto",
                        backgroundColor: "#282828",
                    },
                }}
            >
                <DialogTitle>{type == 'CDL' ? 'CDL Download' : 'Available Exports'}</DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '400px', height: '400px', overflow: 'auto' }}>
                        {exports.map((exp, index) => {
                            return (
                                <ItemList
                                    key={index}
                                    title={exp['name']} 
                                    label={exp['type']} 
                                    disabled={exp['action'] != 'upload_inject' && selectCount == 0}
                                    disabledReason="Select at least one shot"
                                    onItemClick={() => {
                                        if (exp['action'] == 'download'){
                                            return downloadExport(exp)
                                        }
                                        else if(exp['action'] == 'generate_inject'){
                                            // Generate EDL with CDL inserted
                                            return generateCDLEDL({"source": exp["source"]})

                                        }else if(exp['action'] == 'upload_inject'){
                                            toggleCdlUploadMenu()
                                            setCdlUploadSource(exp["source"])
                                        }
                                    }}
                                />
                            )
                        })}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} sx={{ color: 'white' }}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
